<div class="container-fluid padding-top padding-bottom">
  <div *ngIf="stats"
       class="row margin-bottom">
    <div class="col-sm-3">
      <md-card class="stat-block text-center">
        <h3>
          <b>Units Rented</b>
        </h3>
        <h1>{{ stats?.current_month_rentals || 'None Yet' }}</h1>
        <h4 class="mt-4">{{ stats?.last_month_rentals || 'None' }} last month</h4>
        <h4 class="mt-4">{{ stats?.total_rentals || 0 }} total</h4>
      </md-card>
    </div>

    <div class="col-sm-3">
      <md-card class="stat-block text-center">
        <h3>
          <b>Renting Payments</b>
        </h3>
        <h1>{{ (stats?.current_month_renting_payments || 0) | currency:'USD':'symbol-narrow':'.2-2' }}</h1>
        <h4 class="mt-4">{{ (stats?.last_month_renting_payments || 0) | currency:'USD':'symbol-narrow':'.2-2' }} last
          month</h4>
        <h4 class="mt-4">{{ (stats?.total_renting_payments || 0) | currency:'USD':'symbol-narrow':'.2-2' }} total</h4>
      </md-card>
    </div>

    <div class="col-sm-3">
      <md-card class="stat-block text-center">
        <h3>
          <b>Units Reserved</b>
        </h3>
        <h1>{{ stats?.current_month_reservations || 'None Yet' }}</h1>
        <h4 class="mt-4">{{ stats?.last_month_reservations || 'None' }} last month</h4>
        <h4 class="mt-4">{{ stats?.total_reservations || 'None' }} total</h4>
      </md-card>
    </div>

    <div class="col-sm-3">
      <md-card class="stat-block text-center">
        <h3>
          <b>Online Payments ({{ stats?.current_month_of_payments || 'N/A' }})</b>
        </h3>
        <h1>{{ (stats?.current_month_payment_amount || 0) | currency:'USD':'symbol-narrow':'.2-2' }}</h1>
        <h4 class="mt-4">{{ (stats?.last_month_payment_amount || 0) | currency:'USD':'symbol-narrow':'.2-2' }}
          ({{ stats?.last_month_of_payments || 'N/A' }}) last month</h4>
        <h4 class="mt-4">{{ (stats?.total_payment_amount || 0) | currency:'USD':'symbol-narrow':'.2-2' }}
          ({{ stats?.total_of_payments || 'N/A' }}) total</h4>
      </md-card>
    </div>
  </div>

  <md-card>
    <div *ngIf="clientData; else loading">
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-primary"
                  color="primary"
                  (click)="goBack()">Go Back</button>
        </div>
        <div class="col-md-12 text-center">
          <img src="{{ clientData.logoUrl }}"
               class="logo"
               alt="">
          <h1>{{ clientData.name}}</h1>
          <h4 style="margin:15px 0">code: {{ clientData.code }}</h4>
          <h4 style="margin:15px 0"><a [href]="clientData.siteUrl"
               target="_blank">{{ clientData.siteUrl }}</a></h4>
          <button class="btn btn-secondary"
                  (click)="afService.updateSettingsOnServer(clientData)">Update Settings on Server</button>
        </div>
      </div>
      <div class="row margin-bottom">
        <div class="col-md-12 button-wrapper">
          <div class="btn-group center-block">
            <div class="btn-group"
                 dropdown>
              <button dropdownToggle
                      type="button"
                      class="btn btn-default btn-lg btnCheckbox "
                      [routerLink]="['./settings/component-structure']">
                <em class="icon-fire"></em>&nbsp;&nbsp;Styles
              </button>

            </div>

            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="warm"
                   uncheckable
                   [routerLink]="['./settings/component-data']">
              <em class="icon-docs"></em>&nbsp;&nbsp;Component Data</label>
            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="cold"
                   uncheckable
                   [routerLink]="['./settings/page']">
              <em class="icon-direction"></em>&nbsp;&nbsp;Page Settings</label>
            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="cold"
                   uncheckable
                   [routerLink]="['./settings/blog']">
              <em class="icon-screen-tablet"></em>&nbsp;&nbsp;Blog</label>
            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="cold"
                   uncheckable
                   [routerLink]="['./settings/custom-pages']">
              <em class="icon-book-open"></em>&nbsp;&nbsp;Custom Pages</label>
            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="cold"
                   uncheckable
                   [routerLink]="['./settings/size-guide']">
              <em class="icon-calculator"></em>&nbsp;&nbsp;Size Guide</label>
            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="cold"
                   uncheckable
                   [routerLink]="['./settings/integrations']">
              <em class="icon-layers "></em>&nbsp;&nbsp;Custom Tags</label>
            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="cold"
                   uncheckable
                   [routerLink]="['./settings/seo']">
              <em class="icon-bulb"></em>&nbsp;&nbsp;SEO</label>
            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="warm"
                   uncheckable
                   [routerLink]="['./settings/portable-settings']">
              <em class="icon-rocket "></em>&nbsp;&nbsp;Portable Settings</label>
            <label class="btn btn-default btn-lg"
                   name="radioModel"
                   btnRadio="warm"
                   uncheckable
                   [routerLink]="['./settings/reviews']">
              <em class="icon-note"></em>&nbsp;&nbsp;Reviews</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <scs-navigation-item [clientData]="clientData"
                               [navItems]="navItems"></scs-navigation-item>
          <h5>AutoPay Terms</h5>
          <textarea pInputTextarea
                    (change)="updateClient()"
                    [(ngModel)]="clientData.autoPayTerms"
                    id="autoPayTerms"
                    cols="50"
                    rows="6"></textarea>
          <h5>Country</h5>
          <p>So far, this is only used for Canadian portable clients</p>
          <p-dropdown [options]="countryDropdown"
                      (onChange)="updateClient()"
                      [(ngModel)]="clientData.country"
                      placeholder="Select"></p-dropdown>
        </div>
        <div class="col-md-6">
          <!-- <h5>
            <b>Cache:</b>
          </h5> -->
          <!-- <div class="row">
            <div class="col-md-4">
              <label for="cacheExpiration">Settings Cache Expiration (in seconds) </label>
              <label for="df">2592000 = 1 month</label>
            </div>
            <div class="col-md-8">
              <input type="number"
                     (change)="updateClient()"
                     pInputText
                     id="cacheExpiration"
                     class="full-width"
                     [(ngModel)]="clientData.cacheExpireSeconds" />
            </div>
          </div> -->
          <h5>
            <b>Hubspot:</b>
          </h5>
          <div class="row">
            <div class="col-md-4">
              <label *ngIf="clientData.hubspotCompanyId; else noHubspotId"
                     for="hubspotCompanyId">
                <a [style.color]="'#337ab7'"
                   [style.text-decoration]="'underline'"
                   [href]="'https://app.hubspot.com/contacts/3852224/company/'+clientData.hubspotCompanyId"
                   target="_blank"
                   rel="noopener">
                  Hubspot Company ID
                </a>
              </label>
              <ng-template #noHubspotId>
                <label for="hubspotCompanyId">Hubspot Company ID</label>
              </ng-template>
            </div>
            <div class="col-md-8">
              <input type="number"
                     (change)="updateClient()"
                     pInputText
                     id="hubspotCompanyId"
                     class="full-width"
                     [(ngModel)]="clientData.hubspotCompanyId" />
            </div>
          </div>
          <h5>
            <b>Logo URL:</b>
          </h5>
          <div class="col-md-4">
            <label for="favicion">Logo URL</label>
          </div>
          <div class="col-md-8">
            <input (change)="updateClient()"
                   pInputText
                   id="favicion"
                   class="full-width"
                   [(ngModel)]="clientData.logoUrl" />
          </div>
          <h5>
            <b>Favicon:</b>
          </h5>
          <div class="col-md-4">
            <label for="favicion">Favicon URL</label>
          </div>
          <div class="col-md-8">
            <input (change)="updateClient()"
                   pInputText
                   id="favicion"
                   class="full-width"
                   [(ngModel)]="clientData.faviconUrl" />
            <md-slide-toggle [(ngModel)]="clientData.useFavicon"
                             (change)="updateUseFaviconToggle($event)">
              Use favicon url instead of logo
            </md-slide-toggle>
          </div>
          <h5>
            <b>Square Logo:</b>
          </h5>
          <div class="col-md-4">
            <label for="square-logo">Square Logo URL</label>
          </div>
          <div class="col-md-8">
            <input (change)="updateClient()"
                   pInputText
                   id="square-logo"
                   class="full-width"
                   [(ngModel)]="clientData.squareLogoUrl" />
          </div>
          <h5>
            <b>Font:</b>
          </h5>
          <div class="col-xs-12">
            <label for="fontUrl">Font URLs</label>
          </div>
          <div *ngFor="let fontUrl of clientData?.fontUrls; let index = index"
               class="col-xs-12">
            <input pInputText
                   style="width:calc(100% - 90px)"
                   [(ngModel)]="clientData.fontUrls[index]" />
            <button type="button"
                    class="btn btn-danger"
                    color="primary"
                    (click)="removeFontUrl(index)">Remove</button>
          </div>
          <div style="text-align:right;margin-top:10px"
               class="col-xs-12">
            <button type="button"
                    class="btn btn-secondary"
                    color="primary"
                    (click)="clientData?.fontUrls?.push(null)">Add</button>
            <button type="button"
                    class="btn btn-primary"
                    color="primary"
                    (click)="updateClient()">Save</button>
          </div>
          <div class="col-md-12 sm-padding-top">
            <md-slide-toggle id="useSms"
                             (change)="updateAbbreviateStates($event)"
                             [(ngModel)]="clientData.abbreviateStates">
              Abbreviate State names on forms
            </md-slide-toggle>
          </div>
          <br>
          <div *ngIf="locationsDropdown.length > 1"
               class="margin-top">
            <b class="d-block">Default Location:</b>
            <div class="col-md-12">
              <p-dropdown [options]="locationsDropdown"
                          (onChange)="updateClient()"
                          [(ngModel)]="clientData.defaultLocationKey"
                          placeholder="Select"></p-dropdown>
            </div>
            <!-- <div class="col-md-12">
              <md-slide-toggle id="useGeolocation"
                               (change)="updateUseGeoLocation($event)"
                               [(ngModel)]="clientData.useGeolocation">
                Use Geolocation to pick default location
              </md-slide-toggle>
            </div> -->
            <div class="col-md-12">
              <md-slide-toggle id="useSms"
                               (change)="updateUseSms($event)"
                               [(ngModel)]="clientData.useSms">
                Use sms: instead of tel: in phone links
              </md-slide-toggle>
            </div>
            <div class="col-md-12">
              <md-slide-toggle id="clearOutSelectedLocationWhenNavigatingHome"
                               (change)="updateclearOutSelectedLocationWhenNavigatingHome($event)"
                               [(ngModel)]="clientData.clearOutSelectedLocationWhenNavigatingHome">
                Clear out selected location when you go to the home Route
              </md-slide-toggle>
            </div>
            <div class="col-md-12">
              <md-slide-toggle id="goToLocationHomeOnLogoClick"
                               (change)="updateGoToLocationHomeOnLogoClick($event)"
                               [(ngModel)]="clientData.goToLocationHomeOnLogoClick">
                Go to location home on logo click
              </md-slide-toggle>
            </div>
            <div class="col-md-12">
              <md-slide-toggle id="corporateHomeLink"
                               (change)="updateUseCorporateHomeLink($event)"
                               [(ngModel)]="clientData.useCorporateHomeLink">
                display corporate home link
              </md-slide-toggle>
            </div>
            <div class="col-md-12">
              <md-slide-toggle id="showLocationNameInsteadOfClientName"
                               (change)="updateShowLocationNameInsteadOfClientName($event)"
                               [(ngModel)]="clientData.showLocationNameInsteadOfClientName">
                show location name instead of client name where applicable
              </md-slide-toggle>
            </div>
            <div class="col-md-12">
              <md-slide-toggle id="portableMode"
                               (change)="updatePortableMode($event)"
                               [(ngModel)]="clientData.portableMode">
                portable mode
              </md-slide-toggle>
            </div>
          </div>
          <div class="col-md-12">
            <h5>JSON-LD Description</h5>
            <textarea pInputTextarea
                      (change)="updateClient()"
                      [(ngModel)]="clientData.description"
                      id="description"
                      cols="30"
                      rows="4"></textarea>


          </div>
        </div>
      </div>

      <div class="row sm-padding-top">
        <div class="col-md-4">
          <md-slide-toggle (change)="updateShowAnnouncement($event)"
                           [(ngModel)]="clientData.showAnnouncement">
            <p> Show Announcement at the top of all pages</p>
          </md-slide-toggle>
          <div class="mb-5 d-flex flex-column">

            <h5 class="mb-4">Announcement Banner Settings</h5>
            <textarea pInputTextarea
                      [froalaEditor]="options"
                      [(froalaModel)]="clientData.announcementText"
                      id="announcementText"
                      cols="30"
                      rows="4"></textarea>
            <button type="button"
                    class="btn btn-primary mt-4 ml-auto"
                    (click)="updateClient()">Save</button>
          </div>
          <div>
            <label for="announcementBgColor">Announcement BG Color</label>
            <input (change)="updateClient()"
                   pInputText
                   id="announcementBgColor"
                   class="full-width"
                   [(ngModel)]="clientData.announcementBgColor" />
          </div>
          <div>
            <label for="announcementColor">Announcement Color</label>
            <input (change)="updateClient()"
                   pInputText
                   id="announcementColor"
                   class="full-width"
                   [(ngModel)]="clientData.announcementColor" />
          </div>
          <div>
            <label for="announcementFontSize">Announcement Font Size</label>
            <input (change)="updateClient()"
                   pInputText
                   id="announcementFontSize"
                   class="full-width"
                   [(ngModel)]="clientData.announcementFontSize" />
          </div>
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="col-xs-12">
              <h5>Social Media Links</h5>
              <md-slide-toggle (change)="updateShowSocialLinks($event)"
                               [(ngModel)]="clientData.showSocialLinks">
                <p> Show same social links in footer for all locations -- location specific will override</p>
              </md-slide-toggle>
              <p>
                To make them location-specific, go to each location.
              </p>
              <div>
                <label for="socialMediaFooterBlurb">Social Media Footer Blurb</label>
                <input (change)="updateClient()"
                       pInputText
                       id="socialMediaFooterBLurb"
                       [(ngModel)]="clientData.socialMediaFooterBlurb" />
              </div>
              <p>
                <a target="_blank"
                   href="https://app.hubspot.com/file-manager-beta/3852224/folder/Social%20Media%20Icons">
                  Click here
                </a> for the icon options.
              </p>

              <div *ngFor="let link of clientData.socialLinks; let index = index">
                <img style="display:inline-block;width:5%"
                     [src]="clientData.socialLinks[index].iconUrl">
                <input pInputText
                       style="display:inline-block;margin-top:15px;width:37.5%"
                       placeholder="url"
                       [(ngModel)]="clientData.socialLinks[index].url" />
                <input pInputText
                       style="display:inline-block;margin-top:15px;width:37.5%"
                       placeholder="icon url"
                       [(ngModel)]="clientData.socialLinks[index].iconUrl" />
                <button type="button"
                        class="btn btn-primary"
                        color="primary"
                        style="margin-top:15px;margin-left:5%;width:10%"
                        (click)="removeSocialLink(index)">Remove</button>
              </div>

              <button type="button"
                      class="btn btn-accent"
                      color="accent"
                      style="margin-top:15px;"
                      (click)="clientData.socialLinks.push({url: null, iconUrl: null})">Add Link</button>
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      style="margin-top:15px;"
                      (click)="updateClient()">Save Links</button>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <h5>Corporate Contact Info</h5>
              <md-slide-toggle (change)="updateUseCorporateContactInfo($event)"
                               [(ngModel)]="clientData.useCorporateContactInfo">
                <p> Use Corporate Contact info if no location is selected</p>
              </md-slide-toggle>
              <md-slide-toggle (change)="updateUseCorporateContactPage($event)"
                               [(ngModel)]="clientData.useCorporateContactPage">
                <p>Allow contact page with no location selected, which defaults to corporate contact info</p>
              </md-slide-toggle>
            </div>
            <div class="col-xs-12"
                 *ngIf="clientData.useCorporateContactInfo">
              <div class="row">
                <div class="col-xs-6">
                  <div>
                    <label for="corporateAddress">Corporate Address</label>
                  </div>
                  <div>
                    <input (change)="updateClient()"
                           pInputText
                           class="full-width"
                           id="corporateAddress"
                           [(ngModel)]="clientData.corporateAddress" />
                  </div>
                  <div>
                    <label for="corporateAddress2">[City], [State] [Zip]</label>
                  </div>
                  <div>
                    <input (change)="updateClient()"
                           pInputText
                           class="full-width"
                           id="corporateAddress2"
                           [(ngModel)]="clientData.corporateAddress2" />
                  </div>
                </div>
                <div class="col-xs-6">
                  <div>
                    <label for="corporatePhone">Corporate Phone</label>
                  </div>
                  <div>
                    <p-inputMask id="corporatePhone"
                                 class="full-width"
                                 mask="(***) ***-****"
                                 (change)="updateClient()"
                                 [(ngModel)]="clientData.corporatePhone"></p-inputMask>
                  </div>
                  <div>
                    <label for="corporateEmail">Corporate Email</label>
                  </div>
                  <div>
                    <input (change)="updateClient()"
                           pInputText
                           type="email"
                           class="full-width"
                           id="corporateEmail"
                           [(ngModel)]="clientData.corporateEmail" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row sm-padding-top">
        <div class="col-md-12 text-center">
          <h5>Custom JS (Runtime)</h5>
          <textarea pInputTextarea
                    (change)="updateClient()"
                    [(ngModel)]="clientData.customJs"
                    class="full-width"
                    id="custom-js"
                    cols="30"
                    rows="4"></textarea>
        </div>
      </div>

      <div class="row sm-padding-top">
        <div class="col-xs-12 col-sm-6 text-center">
          <h5>Custom HTML/JS end of head (Build time)</h5>
          <textarea pInputTextarea
                    (change)="updateClient()"
                    [(ngModel)]="clientData.customBuildtimeJsHead"
                    class="full-width"
                    id="custom-js-head"
                    rows="10"></textarea>
        </div>

        <div class="col-xs-12 col-sm-6 text-center">
          <h5>Custom HTML/JS end of body (Build time)</h5>
          <textarea pInputTextarea
                    (change)="updateClient()"
                    [(ngModel)]="clientData.customBuildtimeJsBody"
                    class="full-width"
                    id="custom-js-body"
                    rows="10"></textarea>
        </div>
      </div>

      <div class="row sm-padding-top">
        <div class="col-md-12 text-center">
          <h5>Home Page Component Order</h5>
          <br>
          <br>
          <div class="row">
            <div class="col-xs-12">
              <div class="col-xs-6 col-md-4">
                <div class="card card-outline-primary mb-3">
                  <div class="card-header card-inverse card-primary">
                    Home Page Components
                  </div>
                  <div [dragula]="'dropdown-bag'"
                       [dragulaModel]="homepageComponentsAll"
                       id="left"
                       class="sortable-wrapper">
                    <div *ngFor="let item of homepageComponentsAll"
                         [id]="item.value"
                         class="sortable-item">{{item?.name}}</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-md-4">
                <div class="card card-outline-primary mb-3">
                  <div class="card-header card-inverse card-primary">
                    Component Order
                  </div>
                  <div [dragula]="'dropdown-bag'"
                       [dragulaModel]="clientData?.homepageComponentsOrder"
                       id="right"
                       class="sortable-wrapper">
                    <div *ngFor="let item of clientData?.homepageComponentsOrder"
                         [id]="item.value"
                         class="sortable-item">{{item?.name}}</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-md-4">
                <div class="card card-outline-primary mb-3">
                  <div class="card-header card-inverse card-primary">
                    Delete
                  </div>
                  <div [dragula]="'dropdown-bag'"
                       [dragulaModel]="deleteArray"
                       id="delete"
                       class="sortable-wrapper">
                    <div class="sortable-item">Drag here to delete</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--          <md-slide-toggle id="changeHomePageOrder"
                           (change)="updateChangeHomePageOrder($event)"
                           [(ngModel)]="clientData.changeHomePageOrder">Change Component Order</md-slide-toggle>

          <br>
          <br>
         <div *ngIf="clientData?.changeHomePageOrder == true">
            <div class="col-xs-6 col-md-4">
              <div class="card card-outline-primary mb-3">
                <div class="card-header card-inverse card-primary">
                  Home Page Components
                </div>
                <div class="card-block scroll-list">
                  <div class="list-group">
                    <li class="list-group-item list-group-item-action list-group-item-success"
                        [draggable]
                        *ngFor="let item of homepageComponentsAll"
                        [dragClass]="'active'"
                        [dragData]="item"
                        [dragScope]="'default'">
                      {{ item.name }}
                    </li>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-md-4">
              // (onDrop)="addUnitTypeToUnitTypes($event)"
              <div class="card card-outline-success mb-3"
                   droppable
                   [dragOverClass]="'drag-target-border-green'"
                   (onDrop)="changeComponentOrder($event)"
                   [dropScope]="'default'"
                   [dragHintClass]="'drag-hint'">
                <div class="card-header card-inverse card-success">
                  Component Order
                </div>
                <div class="card-block scroll-list">
                  <div class="list-group">
                    <li class="list-group-item list-group-item-action list-group-item-success"
                        [draggable]
                        *ngFor="let item of clientData?.homepageComponentsOrder"
                        [dragClass]="'active'"
                        [dragData]="item"
                        [dragScope]="'default'">
                      {{ item.name }}
                    </li>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-md-4">

              <div class="card card-outline-danger mb-3"
                   droppable
                   [dragOverClass]="'drag-target-danger'"
                   (onDrop)="deleteComponent($event)"
                   [dropScope]="'default'"
                   [dragHintClass]="'drag-hint'">
                <div class="card-header card-inverse card-danger">
                  Remove Order
                </div>
                <div class="card-block scroll-list">
                  <div class="list-group"
                       style="margin-bottom: 0px;">
                    <li class="list-group-item list-group-item-action list-group-item-danger">
                      Delete
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="row sm-padding-top">
        <div class="col-md-12 text-center">
          <h5>Location Home Page Component Order</h5>
          <br>
          <br>
          <div class="row">
            <div class="col-xs-12">
              <div class="col-xs-6 col-md-4">
                <div class="card card-outline-primary mb-3">
                  <div class="card-header card-inverse card-primary">
                    Location Home Page Components
                  </div>
                  <div [dragula]="'location-dropdown-bag'"
                       [dragulaModel]="locationHomepageComponentsAll"
                       id="location-left"
                       class="sortable-wrapper">
                    <div *ngFor="let item of locationHomepageComponentsAll"
                         [id]="item.value"
                         class="sortable-item">{{item?.name}}</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-md-4">
                <div class="card card-outline-primary mb-3">
                  <div class="card-header card-inverse card-primary">
                    Component Order
                  </div>
                  <div [dragula]="'location-dropdown-bag'"
                       [dragulaModel]="clientData?.locationHomepageComponentsOrder"
                       id="location-right"
                       class="sortable-wrapper">
                    <div *ngFor="let item of clientData?.locationHomepageComponentsOrder"
                         [id]="item.value"
                         class="sortable-item">{{item?.name}}</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-md-4">
                <div class="card card-outline-primary mb-3">
                  <div class="card-header card-inverse card-primary">
                    Delete
                  </div>
                  <div [dragula]="'location-dropdown-bag'"
                       [dragulaModel]="locationComponentDeleteArray"
                       id="location-delete"
                       class="sortable-wrapper">
                    <div class="sortable-item">Drag here to delete</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p-dialog header="Add New Location From Onboarding Form Submission"
                [(visible)]="displayOnboardingDialog"
                [responsive]="true"
                [width]="1000"
                [resizable]="true"
                showEffect="fade"
                [modal]="true"
                [dismissableMask]="true"
                [positionTop]="50">
        <div class="panel-group"
             id="accordion"
             role="tablist"
             aria-multiselectable="true">

          <div *ngFor="let loc of onboardingLocations"
               class="panel panel-default">
            <div class="panel-heading"
                 role="tab"
                 id="headingOne">
              <h3 class="panel-title">
                <a class="collapsed"
                   role="button"
                   data-toggle="collapse"
                   data-parent="#accordion"
                   href="#{{ loc.id }}"
                   aria-expanded="true"
                   aria-controls="collapseOne">
                  {{ loc.location_name || loc.locationName }} -
                  {{ loc.isTypeform ? loc.fullName : loc.firstName +' '+ loc.lastName }}
                </a>
              </h3>
            </div>
            <div id="{{loc.id}}"
                 class="panel-collapse collapse"
                 role="tabpanel"
                 aria-labelledby="headingOne">
              <div class="panel-body">
                <app-onboarding-location-view [loc]="loc"
                                              [isTypeform]="loc.isTypeform"></app-onboarding-location-view>
                <br>
                <br>
                <div *ngIf="onboardingLocationKeyIsDuplicate"
                     class="row">
                  <div class="col-md-12">
                    <div class="error">
                      Location key is already in use
                    </div>
                  </div>
                </div>
                <div *ngIf="onboardingLocationKeyIsEmpty"
                     class="row">
                  <div class="col-md-12">
                    <div class="error">
                      Location key is required
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-lg btn-primary"
                            style="float: right;"
                            (click)="newLocationFromOnboarding(loc, loc.isTypeform)">Add Location</button>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </p-dialog>


      <p-dialog header="Location Details"
                [(visible)]="displayLocationDialog"
                [responsive]="true"
                [width]="500"
                [resizable]="true"
                showEffect="fade"
                (onHide)="sitelinkCredsValid = null"
                [modal]="true"
                [dismissableMask]="true"
                [positionTop]="50">
        <div class="ui-grid ui-grid-responsive ui-fluid"
             *ngIf="location">
          <div class="row sm-padding-top">
            <div class="col-md-4">
              <label for="name">Name</label>
            </div>
            <div class="col-md-8">
              <input pInputText
                     id="name"
                     [(ngModel)]="location.name" />
            </div>
          </div>
          <div *ngIf="location.$key"
               class="row sm-padding-top">
            <div class="col-md-4">
              <label for="name">Location Key</label>
            </div>
            <div class="col-md-8">
              <input pInputText
                     disabled
                     id="location-key-disabled"
                     [(ngModel)]="location.$key" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-4">
              <label for="tagLine">Tag Line</label>
            </div>
            <div class="col-md-8">
              <input pInputText
                     id="tagLine"
                     [(ngModel)]="location.tagLine" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-4">
              <label for="address">Address</label>
            </div>
            <div class="col-md-8">
              <input pInputText
                     id="address"
                     [(ngModel)]="location.address" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-4">
              <label for="address2">[City], [State] [Zip]</label>
            </div>
            <div class="col-md-8">
              <input pInputText
                     id="address2"
                     [(ngModel)]="location.address2" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-4">
              <label for="address2">State (For Location Bar by State)</label>
            </div>
            <div class="col-md-8">
              <p-dropdown [options]="states"
                          filter="true"
                          [(ngModel)]="location.state"
                          placeholder="Select"></p-dropdown>
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-4">
              <label for="phone">Phone</label>
            </div>
            <div class="col-md-8">
              <p-inputMask id="phone"
                           mask="(***) ***-****"
                           [(ngModel)]="location.phone"></p-inputMask>
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-4">
              <label for="smsPhone">SMS Phone</label>
            </div>
            <div class="col-md-8">
              <p-inputMask id="smsPhone"
                           mask="(***) ***-****"
                           [(ngModel)]="location.smsPhone"></p-inputMask>
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-3">
              <label for="email">Email</label>
            </div>
            <div class="col-md-9">
              <input pInputText
                     id="email"
                     [(ngModel)]="location.email" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-3">
              <label for="imageUrl">Location Image URL</label>
            </div>
            <div class="col-md-9">
              <input pInputText
                     id="imageUrl"
                     [(ngModel)]="location.imageUrl" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-3">
              <label for="imageAlt">Location Image Alt</label>
            </div>
            <div class="col-md-9">
              <input pInputText
                     id="imageAlt"
                     [(ngModel)]="location.imageAlt" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-3">
              <label for="imageTitle">Location Image Title</label>
            </div>
            <div class="col-md-9">
              <input pInputText
                     id="imageTitle"
                     [(ngModel)]="location.imageTitle" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-3">
              <label for="latitude">Latitude</label>
            </div>
            <div class="col-md-9">
              <input name="lat"
                     pInputText
                     id="latitude"
                     [(ngModel)]="location.latitude" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <div class="col-md-3">
              <label for="longitude">Longitude</label>
            </div>
            <div class="col-md-9">
              <input name="long"
                     pInputText
                     id="longitude"
                     [(ngModel)]="location.longitude" />
            </div>
          </div>
          <div class="row sm-padding-top">
            <button type="button"
                    class="btn btn-accent"
                    color="accent"
                    (click)="getLatLong()">Get Lat/Long</button>
          </div>

          <hr>
          <div *ngIf="clientData.propertySoftware == 'uhaul'">
            <div class="row sm-padding-top">
              <div class="col-md-12">
                <h4>Uhaul Information</h4>
              </div>
              <div class="col-md-4">
                <label for="siteLinkCorpCode">Location Code</label>
              </div>
              <div class="col-md-8">
                <input pInputText
                       id="uhaulLocationKey"
                       [(ngModel)]="location.uhaulLocationKey" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <br>
                <label for="useUhaulImages">Unit Images</label>
              </div>
              <div class="col-md-8">
                <br>
                <md-slide-toggle id="useUhaulImages"
                                 (change)="updateUhaulImages($event)"
                                 [(ngModel)]="location.useUhaulImages">Use Uhaul Images</md-slide-toggle>
              </div>
            </div>
          </div>
          <div *ngIf="clientData.propertySoftware == 'sitelink'">
            <div class="row sm-padding-top">
              <div class="col-md-12">
                <h4>Sitelink Information</h4>
              </div>
              <div class="col-md-4">
                <label for="siteLinkCorpCode">Corp Code</label>
              </div>
              <div class="col-md-8">
                <input pInputText
                       id="siteLinkCorpCode"
                       (change)="sitelinkCredsValid = null"
                       [(ngModel)]="location.siteLinkCorpCode" />
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-4">
                <label for="siteLinkLocationCode">Location Code</label>
              </div>
              <div class="col-md-8">
                <input pInputText
                       id="siteLinkLocationCode"
                       (change)="sitelinkCredsValid = null"
                       [(ngModel)]="location.siteLinkLocationCode" />
              </div>
            </div>
            <!-- <div class="row sm-padding-top">
              <div class="col-md-4">
                <label for="siteLinkLicenseKey">License Key</label>
              </div>
              <div class="col-md-8">
                <input pInputText
                       id="siteLinkLicenseKey"
                       (change)="sitelinkCredsValid = null"
                       [(ngModel)]="location.siteLinkLicenseKey" />
              </div>
            </div> -->
            <div class="row sm-padding-top">
              <div class="col-md-4">
                <label for="siteLinkCorpUsername">Corp Username</label>
              </div>
              <div class="col-md-8">
                <input pInputText
                       id="siteLinkCorpUsername"
                       (change)="sitelinkCredsValid = null"
                       [(ngModel)]="location.siteLinkCorpUsername" />
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-4">
                <label for="siteLinkLocationPw">Location Password</label>
              </div>
              <div class="col-md-8">
                <input pInputText
                       id="siteLinkLocationPw"
                       (change)="sitelinkCredsValid = null"
                       [(ngModel)]="location.siteLinkLocationPw" />
              </div>
            </div>
            <div class="panel panel-info"
                 *ngIf="location?.onboardingSitelinkCorpCode"
                 style="margin-top: 20px;">
              <div class="panel-heading">
                <h3 class="panel-title">Onboarding Sitelink</h3>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-6">
                    <label>Corp Code</label>
                  </div>
                  <div class="col-md-6">
                    <p>{{location?.onboardingSitelinkCorpCode}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label>Location Code</label>
                  </div>
                  <div class="col-md-6">
                    <p>{{location?.onboardingSitelinkLocationCode}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="sitelinkCredsValid !== null"
                 class="row sm-padding-top">
              <div class="col-md-12 d-flex flex-wrap align-content-center justify-content-center">
                <div *ngIf="sitelinkCredsValid; else invalidSitelinkCreds"
                     class="success">
                  Sitelink creds are valid
                </div>
                <ng-template #invalidSitelinkCreds>
                  <div class="error">
                    Sitelink creds are invalid
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-12 d-flex flex-wrap">
                <button class="btn btn-default"
                        (click)="fillSitelinkDemoDetails()">Fill Demo Details</button>
                <button class="btn btn-secondary ml-auto"
                        (click)="verifySitelinkCreds()">Verify Sitelink Creds</button>
              </div>
            </div>
          </div>

        </div>
        <p-footer>
          <div class="ui-dialog-buttonpane ui-helper-clearfix">
            <button type="button"
                    class="btn btn-primary"
                    color="accent"
                    (click)="saveLocation()">
              <i class="fa fa-check"
                 aria-hidden="true"></i> Save</button>
            <button *ngIf="!isNewLocation"
                    type="button"
                    class="btn btn-default"
                    style="float: left;"
                    (click)="removeLocation()">
              <i class="fa fa-close"
                 aria-hidden="true"></i> Delete</button>
          </div>
        </p-footer>
      </p-dialog>
      <div class="row sm-padding-top">
        <div class="col-md-12 text-center">
          <h5>Locations</h5>
          <h3>After adding a Location you have to update the Caches or nothing will work!</h3>
          <md-slide-toggle id="changeLocationOrder"
                           (change)="updateChangeLocationOrder($event)"
                           [(ngModel)]="clientData.changeLocationOrder">Change Location Order</md-slide-toggle>
        </div>
      </div>
      <div [hidden]="!clientData?.changeLocationOrder"
           class="row">
        <div class="col-xs-12 col-sm-4 col-sm-offset-4 text-center">
          <button class="btn btn-accent btn-lg"
                  [routerLink]="['./settings/locations-data']">Change Order</button>
        </div>
      </div>
      <div class="row sm-padding-top">
        <div class="col-md-12 text-center">
          <p-dataTable [value]="(locations | async)"
                       sortField="name"
                       class="text-center"
                       selectionMode="single"
                       [(selection)]="selectedLocation"
                       (onRowSelect)="onLocationRowSelect($event)"
                       [responsive]="true"
                       #dt>
            <p-header>Locations</p-header>
            <p-column field="imageUrl"
                      header="Image">
              <ng-template let-col
                           let-car="rowData"
                           pTemplate="body">
                <span>
                  <img class="location-image"
                       [src]="car[col.field]"
                       alt="">
                </span>
              </ng-template>
            </p-column>
            <p-column field="name"
                      header="Name"></p-column>
            <p-column field="address"
                      header="Address">
              <ng-template let-col
                           let-car="rowData"
                           pTemplate="body">
                {{car[col.field]}}
                <br>
                {{car['address2']}}
              </ng-template>
            </p-column>
            <p-column field="phone"
                      header="Phone"></p-column>
            <p-column field="email"
                      header="Email"></p-column>
            <p-column field="$key"
                      header="">
              <ng-template let-col
                           let-car="rowData"
                           pTemplate="body">
                <button class="btn btn-secondary btn-lg btn-block"
                        style="padding: 14%;"
                        [routerLink]="['./location/', car[col.field]]">View</button>
              </ng-template>
            </p-column>
            <p-footer>
              <div class="ui-helper-clearfix"
                   style="width:100%">
                <button type="button"
                        class="btn btn-default"
                        color="primary"
                        style="float:left"
                        (click)="showLocationDialogToAdd()">
                  <i class="fa fa-plus"
                     aria-hidden="true"></i> Add
                </button>
                <button type="button"
                        class="btn btn-default"
                        color="primary"
                        style="float:left; margin-left: 10px;"
                        (click)="showAddFromOnboardingDialog()">
                  <i class="fa fa-list-ul"
                     aria-hidden="true"></i> Add From Onboarding
                </button>
              </div>
            </p-footer>
          </p-dataTable>


          <div class="error"
               *ngIf="error">
            {{error}}
          </div>
          <div class="row padding-bottom"
               *ngIf="clientData?.propertySoftware != 'none'">
            <div class="text-center col-xs-12">
              <h2>Update Caches</h2>
              <p>Must be running a local API</p>
              <p>ALWAYS UPDATE THE DISCOUNTS CACHE FIRST. The others use that cache.</p>
            </div>
            <div class="text-center col-xs-12">
              <p>Click this button to update each and every cache.</p>
              <button class="buttons btn btn-primary btn-lg"
                      color="primary"
                      *ngIf="clientData?.propertySoftware == 'sitelink' || clientData?.propertySoftware == 'uhaul'"
                      (click)="updateEachAndEveryCache()">All Facility Cache</button>
              <p>If it errors, manually update the caches in order starting with the one that had an error.</p>
            </div>
            <div class="col-xs-12">
              <div class="row">
                <div class="col-md-3 button-wrapper">
                  <button class="buttons btn btn-accent btn-lg"
                          color="accent"
                          *ngIf="clientData?.propertySoftware == 'sitelink'"
                          (click)="updateDiscountsCache()">1. Discounts</button>
                </div>
                <div class="col-md-3 button-wrapper">
                  <button class="buttons btn btn-accent btn-lg"
                          color="accent"
                          *ngIf="clientData?.propertySoftware == 'sitelink'"
                          (click)="updateInsuranceCache()">2. Insurance</button>
                </div>
                <div class="col-md-3 button-wrapper">
                  <button class="buttons btn btn-accent btn-lg"
                          color="accent"
                          *ngIf="clientData?.propertySoftware == 'sitelink'"
                          (click)="updateAllUnitsCache()">3. All Units</button>
                </div>
                <div class="col-md-3 button-wrapper">
                  <button class="buttons btn btn-accent btn-lg"
                          color="accent"
                          *ngIf="clientData?.propertySoftware == 'sitelink'"
                          (click)="updateAvailbleUnitsCache()">4. Available Units</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </md-card>
</div>
<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>
<div *ngIf="showSpinner">
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/view-client/view-client.component.html